/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.students.scheduling.course-request-set-up'},
});

const CourseRequestSetUpItem = () => (
  <RouteLinkItem
    route="midas/students/scheduling/course-request-set-up"
    title={messages.title}
  />
);

export default CourseRequestSetUpItem;
